export default __webpack_public_path__ + "media/images/icons/thumbs-up-66c1a304bf0c59bafa488cfeb1cccf2f.jpg";